<template>
  <div class="emptyStyle">
    <img :src="getImgUrl(imgName)" alt="empty" class="fb-map">
    <p class="titleStyle green">{{textGreen}}</p>
    <p class="titleStyle grey">{{textGrey}}</p>
  </div>
</template>

<script>
export default {
  props: {
    imgName: {
      type: String,
    },
    textGreen: {
      type: String,
    },
    textGrey: {
      type: String,
    },
  },
  methods: {
    getImgUrl(img) {
      const images = require.context('../../assets/img/', false, /\.svg$/);
      return images(`./${img}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-container {
    font-size: 20px;
    text-align: center;
    color: rgb(192, 204, 218);
  }
  .emptyStyle {
    margin-top: 2em;
  }
  .titleStyle {
    font-size: 2em;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
    &.green {
      color: #AAD500;
    }
    &.grey {
      color: #9B9B9B;
    }
  }
  .fb-map {
    width: 320px;
  }
</style>
